import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "@remotes/fetchProducts";

export function useProducts() {
  return useQuery({
    queryKey: ["useProducts"],
    queryFn: () => fetchProducts(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
} 